"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var TabsContext = exports.TabsContext = /*#__PURE__*/_react["default"].createContext({
  activeTab: '',
  setActiveTab: function setActiveTab(tabId) {
    return '';
  }
});